import classNames from 'classnames'
import { CSSProperties, ForwardedRef, forwardRef } from 'react'
import BaseCheckbox from 'shared/components/base/form/base-checkbox'
import BaseSelect from 'shared/components/base/form/base-select'

import { CategoryType } from './types/category-type'

type PropType = {
  hasSelectComponent: boolean
  style?: CSSProperties
  onCheck: (id: string, isChecked: boolean) => void
  onSelect: (id: string, selectedValue: string) => void
  category: CategoryType
}

const ProductTypeRow = forwardRef(
  (props: PropType, ref: ForwardedRef<HTMLDivElement>) => {
    const { category, onCheck, onSelect, hasSelectComponent, style } = props
    const requestQuantity = [
      { label: 'مقدار درخواستی', value: '', key: '0' },
      { label: 'یک ظرفیت', value: 'eq', key: 'eq' },
      { label: 'کمتر از یک ظرفیت', value: 'lt', key: 'lt' },
      { label: 'بیشتر از یک ظرفیت', value: 'gt', key: 'gt' },
    ]

    return (
      <div
        style={{ ...style }}
        className="grid grid-cols-11 gap-4 pl-2"
        ref={ref}
      >
        <div
          className={
            'flex border-solid border-1 rounded-lg border-[#D8D8D8] col-span-7 items-center py-2 px-4'
          }
        >
          <BaseCheckbox
            label={category.label}
            value={category.value}
            checked={category.isSelected}
            onChange={() => onCheck(category.id, !category.isSelected)}
          />
        </div>
        {hasSelectComponent && (
          <div className="col-span-4">
            <BaseSelect<string>
              disabled={!category.isSelected}
              onSelect={(value) => onSelect(category.id, value)}
              setInputClassName={({ disabled }) =>
                classNames(
                  'pt-1 border-dashed',
                  disabled
                    ? 'border-gray-light text-gray-light'
                    : 'border-gray-medium'
                )
              }
              value={category.selectedValue}
              defaultValue={''}
              options={requestQuantity}
            />
          </div>
        )}
      </div>
    )
  }
)

ProductTypeRow.displayName = 'ProductTypeRow'

export default ProductTypeRow
